import React, { Component } from "react";

// import "../assets/css/logs.css";
import "../assets/css/logs-styles.css";


class LogsDropdown extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...props,
      
      // startClicked: this.props.startClicked
    };
  }


  // componentDidUpdate() {
  //   localStorage.setItem('LogsDropdownState', JSON.stringify(this.state))
  // }

  // componentDidMount() {
  //   this.LogsDropdownUpdatedState = JSON.parse(localStorage.getItem('LogsDropdownState'))
  //   if (localStorage.getItem('LogsDropdownState')) {
  //     this.setState({
       
  //      })
  //   } else {
  //     this.setState({
        
  
  
  //     })
  //    }
  // }

  render() {

    const confirmDialogForLogsPage = () => {
      window.confirm("Click OK to reset, or cancel to go back.") &&
        this.props.logReset();
      
    };

    return (
      <div
        className={"dropdown-container " + (this.props.hidden ? "hide" : "")}
        // className={"dropdown-container " + (this.props.logsHidden ? "hide" : "")}
      >
        <div className="header-row">
          <div className="header-item">
            <span>LOGS</span>
          </div>
          <div className="header-item">
            <span>TIME</span>
          </div>
        </div>
        {   this.props.logsEmpty==false ? 
        <div className="dropdown-items">
          
          <div className="alignment">
            
            <ol className="logs-padding">
              {this.props.hoursLogs.map((hour, index) => (
                <li
                  className="space-numbering"
                  style={{ paddingLeft: "2em" }}
                  key={index}
                >
                  {hour}h<span className="logs-padding">:</span>
                </li>
              ))}
            </ol>
            
            <ol className="logs-margin">
              {this.props.minutesLogs.map((minute, index) => (
                <li className="removeBullet" key={index}>
                  {minute}m<span className="logs-padding">:</span>
                </li>
              ))}
            </ol>
            <ol className="logs-margin">
              {this.props.secondsLogs.map((second, index) => (
                <li className="removeBullet" key={index}>
                  {second}s
                </li>
              ))}
            </ol>
          </div>
          {/* <div className=""> */}

            <ol className="">
              {this.props.dateAndTimeLogs.map((dateAndTime, index) => (
                <li className="removeBullet" key={index}>
                  {dateAndTime}
                </li>
              ))}
            </ol>
          {/* </div> */}
          </div> :
          <div className="dropdown-items"> LOG IS EMPTY </div>
}
        <div className="logs-button-container">
          <button
            className="a-button"
            onMouseOver={() => {
              this.props.logSetToNeutral();
              this.props.setDateAndTime();
            }}
            onClick={() => {
              this.props.alertOnInvalidLogForLogTimerButton();
            }}
          >
            LOG TIMER
          </button>
          <button
               onMouseDown={() => {
                this.props.logSetToRed();
                this.props.setDateAndTime();
              }}
              onMouseOver={() => {
                this.props.logSetToRed();
                this.props.setDateAndTime();
              }}
            className="a-button"
            onClick={() => {
              this.props.addDateAndTimeToLog();
              this.props.addHourToLog();
              this.props.addMinuteToLog();
              this.props.addSecondToLog();
         
              confirmDialogForLogsPage();

            }}
          >
            RESET LOGS
          </button>
        </div>
      </div>
    );
  }
}

export default LogsDropdown;
